import * as styles from "./AlertDialogFooter.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { AlertDialogFooterProps } from "./AlertDialog.types";

export function AlertDialogFooter({
  className,
  ...props
}: AlertDialogFooterProps): JSX.Element {
  return (
    <div
      data-slot="alert-dialog-footer"
      className={clsx(styles.footer, className)}
      {...props}
    />
  );
}
